import img_geschiedenis from "../assets/img/benen_en_instrumenten_vierkant.jpg";
import img_ron from "../assets/img/ron.jpg";
import img_lid from "../assets/img/lid.jpg";
import img_trompet from "../assets/img/trompet.jpg";

export default function About() {
  return (
    <div className="content_container responsive_width">
      <header id="info">
        <div className="about__container">
          <div className="about__row">
            <div className="center">
              <h3>Welkom bij Fanfare Harpe Davids</h3>
              <div className="header_text">
                Waar muziek een verhaal vertelt van passie en vriendschap. Wat
                ooit begon als een traditionele fanfare, is uitgegroeid tot een
                eigentijdse muziekvereniging. Wij zijn meer dan een fanfare; wij
                zijn een hechte muzikale familie die samen groeit, leert en
                bloeit.
              </div>
            </div>
          </div>
          <div className="aside__about">
            <h2 className="tile__title_mobile">Geschiedenis</h2>
            <span className="header_span_mobile"></span>
            <div className="aside">
              <img
                className="about__image"
                src={img_geschiedenis}
                alt="demo"
              ></img>
            </div>
            <div className="aside">
              <div className="tile">
                <div>
                  <h2 className="tile__title">Geschiedenis</h2>
                  <span className="header_span"></span>
                  <div className="text">
                    Het verhaal van Harpe Davids, waarvoor we 90 jaar terug in
                    de tijd gaan, is een verhaal dat het samenspel tussen
                    muziek, vriendschap en geschiedenis weerspiegelt. Reis met
                    ons mee door de tijd en verken de hoogtepunten van de Harp
                    van de afgelopen negen decennia.
                  </div>
                </div>
                <a href="/geschiedenis">
                  <button className="button_primary button_about">
                    Lees meer
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="aside__about">
            <h2 className="tile__title_mobile">Dirigent</h2>
            <span className="header_span_mobile"></span>
            <div className="aside about__ron_mobile">
              <img className="about__image" src={img_ron} alt="demo"></img>
            </div>
            <div className="aside">
              <div className="tile">
                <div>
                  <h2 className="tile__title">Dirigent</h2>
                  <span className="header_span"></span>
                  <div className="text">
                    Sinds 2000 staat Ron Daelemans als dirigent aan het roer bij
                    Fanfare Harpe Davids in Brunssum. Zijn passie voor muziek is
                    nog steeds onverminderd en hij heeft bewezen een
                    buitengewoon trouwe en muzikale leider voor onze vereniging
                    te zijn. Ron heeft de gave om ons telkens weer te motiveren
                    en aan te moedigen om nieuwe muzikale wegen in te slaan. Hij
                    deinst niet terug voor uitdagingen en daagt ons uit om het
                    beste uit onszelf te halen. Zijn bevlogenheid en
                    vastberadenheid inspireren ons om te blijven groeien als
                    muzikanten en als fanfare. <br />
                    <br />
                    Meer dan alleen onze dirigent, is Ron een gewaardeerde
                    mentor en vriend. Zijn leiderschap en warmte hebben een
                    onuitwisbare stempel gedrukt op de identiteit van onze
                    fanfare, en hebben ons gevormd tot de hechte en
                    gepassioneerde groep die we vandaag de dag zijn.
                  </div>
                </div>
              </div>
            </div>
            <div className="aside about__ron">
              <img className="about__image" src={img_ron} alt="demo"></img>
            </div>
          </div>
          <div className="aside__about">
            <h2 className="tile__title_mobile">Lid worden</h2>
            <span className="header_span_mobile"></span>
            <div className="aside">
              <img className="about__image" src={img_trompet} alt="demo"></img>
            </div>
            <div className="aside">
              <div className="tile">
                <h2 className="tile__title">Lid worden</h2>
                <span className="header_span"></span>
                <div className="text">
                  We hebben een divers repertoire en geven verschillende soorten
                  concerten variërend van begeleiding bij kerkdiensten, tot
                  rockconcerten in de schouwburg. <br />
                  <br />
                  Of je nu een doorgewinterde muzikant bent of net begint, bij
                  Fanfare Harpe Davids vind je een thuis waar jouw liefde voor
                  muziek kan floreren. Sluit je aan en ontdek de magie van onze
                  muzikale familie, waar noten samensmelten tot blijvende
                  herinneringen en levenslange vriendschappen.
                  <br />
                  <br />
                  We repeteren elke dinsdagavond van 20.00 tot 22.00 uur in de
                  Pelgrimskerk, Horizonstraat 73, Brunssum. Wil je een keer
                  komen kijken? Je bent van harte welkom. Wil je een keer
                  meespelen? Neem contact met ons op!
                </div>
                <a href="mailto:secretariaat@harpedavidsbrunssum.net?subject=Lidmaatschap&body=Hallo%2C%0A%0AIk%20zou%20graag%20lid%20willen%20worden.%0A%0A%3Cvul%20hier%20je%20contact%20informatie%20in%3E">
                  <button className="button_primary button_about">
                    Word lid
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="aside__about">
            <h2 className="tile__title_mobile">Opleiding</h2>
            <span className="header_span_mobile"></span>
            <div className="aside about__ron_mobile">
              <img className="about__image" src={img_lid} alt="demo"></img>
            </div>
            <div className="aside">
              <div className="tile">
                <div>
                  <h2 className="tile__title">Opleiding</h2>
                  <span className="header_span"></span>
                  <div className="text">
                    Bij Fanfare Harpe Davids is iedereen welkom! Of je nu jong
                    of oud bent, een herintreder of een nieuw muzikaal talent –
                    wij zorgen ervoor dat jij op jouw niveau muziek kunt maken.{" "}
                    <br />
                    <br />
                    We bieden maatwerk voor elke muzikant. Of je nu een
                    blaasinstrument of slagwerk wilt leren spelen, onze lessen
                    worden verzorgd door docenten van het SMK. Met persoonlijke
                    begeleiding en een gezellige sfeer helpen we je om het beste
                    uit jezelf te halen. <br />
                    <br />
                    Benieuwd naar onze opleiding? Laat het ons weten via de knop
                    hieronder en we komen zo snel mogelijk bij je terug!
                  </div>
                  <a
                    href="mailto:secretariaat@harpedavidsbrunssum.net?subject=Opleidingen&body=Hallo%2C%0A%0AIk%20zou%20graag%20meer%20informatie%20willen%20over%20de%20opleidingen.%0A%0A%3Cvul%20hier%20je%20contact%20informatie%20in%3E"
                    params={{}}
                  >
                    <button className="button_primary button_about">
                      Aanmelden
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div className="aside about__ron">
              <img className="about__image" src={img_lid} alt="demo"></img>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}
